<template>
	<div style="width: 100vw;min-height: 100vh;" :style="getBgStyle()" v-loading="loading" v-if="show">
		<div :style="navStyle()" style="width: 100%;margin: auto;">
			<div :style="navBoxStyle()" style="display: flex;justify-content: center;margin: auto;">
				<wm-preview id="navTop" ref="navTop" :style="navBgBoxStyle()" style="overflow: hidden;height: 100%;"
					typeView="preview" :all_setting="all_setting" :po="'top'" :systemConfig="systemConfig"
					:equipment="equipment" v-if="equipment == 'pc'" :list="navList"></wm-preview>
			</div>
		</div>
		<div v-if="!loading" :style="navStyle()" style="width: 100%;">
			<wm-preview id="phoneNav" ref="phoneNav" :style="navBgBoxStyle()" style="width: 100%;" typeView="preview"
				:all_setting="all_setting" :po="'top'" :systemConfig="systemConfig" :equipment="equipment"
				v-if="equipment == 'phone'" :list="navPhoneList"></wm-preview>
		</div>
		<div style="width: 1px;" :style="{height:placeNavHeight + 'px'}"></div>
		<div v-if="!loading" :style="getStyle()" style="margin: auto;height: 100%;">
			<div :style="getBoxStyle()" style="height: 100%;width: 100%;">
				<wm-preview  typeView="preview" :all_setting="all_setting" :systemConfig="systemConfig"
					:equipment="equipment" :list="centerList"></wm-preview>
			</div>
		</div>
		
		<wm-preview  typeView="preview" :all_setting="all_setting" :systemConfig="systemConfig"
			:equipment="equipment" :list="centerList"></wm-preview>
		<div v-if="!loading" :style="footStyle()" style="width: 100%;margin: auto;">
			<div :style="footBoxStyle()" style="margin: auto;">
				<wm-preview :style="footBgBoxStyle()" style="overflow: hidden;height: 100%;" typeView="preview"
					:all_setting="all_setting" :systemConfig="systemConfig" :equipment="equipment"
					v-if="equipment == 'pc'" :list="footerList"></wm-preview>
			</div>
		</div>
		<div v-if="!loading" :style="footStyle()">
			<wm-preview :style="footBgBoxStyle()" typeView="preview" :all_setting="all_setting"
				:systemConfig="systemConfig" :equipment="equipment" v-if="equipment == 'phone'"
				:list="footerPhoneList"></wm-preview>
		</div>
		<div v-if="equipment == 'phone'" style="height:60px ;width: 1px;"></div>
	</div>
</template>

<script>
	import {
		getDesignSave,
		getSetting,
		getDesignHome,
		getDesignShow
	} from '../api/all.js'
	import apiConfig from './config/apiConfig.js'
	import {
		mapState,
		mapGetters,
		mapActions,
		mapMutations
	} from 'vuex';
	import wmPreview from './components/preview.vue'
	import config from './config.js'
	export default {
		components: {
			wmPreview
		},
		computed: {},
		data() {
			return {
				placeNavHeight: 0,
				centerList: [],
				config,
				fontList: [],
				all_setting: [],
				loading: false,
				show: true,
				equipment: 'phone',
				navList: [],
				homeList: [],
				footerList: [],
				footerPhoneList: [],
				navPhoneList: [],
				systemConfig: null,
				bottomCartPhoneList: []
			}
		},
		async mounted() {
			this.loading = true
			console.log(this.$route)
			let that = this
			// console.log('window.screen.width', window.screen.width)
			if (window.innerWidth > 1200) {
				// 当前设备是移动设备 
				this.equipment = 'pc'
			} else {
				this.equipment = 'phone'
			}

			let wsid = this.$cookies.get("wsid")
			let systemConfig = await getSetting({
				wsid
			})

			let showData = await getDesignShow({
				wsid,
			})

			if (showData.data.data.all_setting.data) {
				this.all_setting = JSON.parse(showData.data.data.all_setting.data)
				console.log('showData', this.all_setting)
			}
			this.systemConfig = systemConfig.data.data
			window.onresize = function(e) {
				// console.log('e',e)
				// console.log("agag screen")
				// console.log("window.screen.width",window.screen.width)
				if (window.innerWidth > 1200) {
					// 当前设备是移动设备 
					that.equipment = 'pc'
				} else {
					that.equipment = 'phone'
				}
				console.log('that.navPhoneList', that.navPhoneList)
				console.log('that.equipment', that.equipment);

				// that.show = false
				// that.$nextTick(() => {
				// 	that.show = true
				// })

			};

			// await this.requestData()
			that.$nextTick(async () => {
				// 页眉
				that.navList = JSON.parse(localStorage.getItem('navList'));
				console.log('that.navList', that.navList)
				that.navPhoneList = JSON.parse(localStorage.getItem('navPhoneList'));
				console.log('that.navPhoneList', that.navPhoneList)
				//内容
				// that.homeList = JSON.parse(localStorage.getItem('homeList'));
				// that.detailList = JSON.parse(localStorage.getItem('detailList'));
				let filed = localStorage.getItem('filed')
				if (filed != 'navList' && filed != 'navPhoneList' && filed != 'footerList' && filed !=
					'footerPhoneList') {
					this.centerList = JSON.parse(localStorage.getItem(filed));
					console.log('this.centerLis123t', JSON.parse(localStorage.getItem(filed)))
				}

				// 页尾
				that.footerList = JSON.parse(localStorage.getItem('footerList'));
				that.footerPhoneList = JSON.parse(localStorage.getItem('footerPhoneList'));
				// that.bottomCartPhoneList = JSON.parse(localStorage.getItem('bottomCartPhoneList'));
				that.all_setting = JSON.parse(localStorage.getItem('all_setting'));
				console.log('that.bottomCartPhoneList', that.bottomCartPhoneList)
				await this.requestFun(filed)
			})
			this.loading = false
		},

		watch: {
			
		},
		updated() {
			if (this.equipment == 'pc') {
				if (this.$refs.navTop) {
					let navTop = document.getElementById('navTop')
					console.log('this.placeNavHeight', navTop.offsetHeight)
					if(this.all_setting.length > 0) {
						let setItem = this.all_setting[0].tabList[0].config.nav
						if (setItem.navSetHeight.toTop) {
							this.placeNavHeight = navTop.offsetHeight
							// console.log('this.placeNavHeight',this.placeNavHeight)
						}
					}
					
				}
			} else {
				console.log('this.$refs.phoneNav', this.$refs.phoneNav)
				if (this.$refs.phoneNav) {
					let phoneNav = document.getElementById('phoneNav')
					if(this.all_setting.length > 0) {
						let setItem = this.all_setting[0].tabList[0].config.nav
						if (setItem.navSetHeight.toTop) {
							this.placeNavHeight = phoneNav.offsetHeight
							console.log('this.placeNavHeight', this.placeNavHeight)
						}
					}
				}
			}

		},
		methods: {

			// style
			getBgStyle() {
				try {
					if (this.all_setting.length > 0) {
						let setItem = this.all_setting[0].tabList[0].config
						let style = {}
						if (setItem.bg.bgType == 'checked1') {
							style.background = setItem.bg.singleBgColor.bgColor
						}
						if (setItem.bg.bgType == 'checked2') {
							return setItem.bg.bgColor.bgColor
						}
						if (setItem.bg.bgType == 'checked3') {
							let backgroundImage = `url(${setItem.bg.bgImg.url})`
							if (setItem.bg.bgImg.width) {
								style.backgroundSize = setItem.bg.bgImg.width + 'px';
							} else {
								style.backgroundSize = '100%';
							}
							if (setItem.bg.bgImg.height) {
								style.backgroundSize = style.backgroundSize + ' ' + (setItem.bg.bgImg.height +
									'px')
							} else {
								style.backgroundSize = style.backgroundSize + ' 100%'
							}
							if (setItem.bg.bgImg.type) {
								style.backgroundRepeat = setItem.bg.bgImg.type
							}
							if (setItem.bg.bgImg.position) {
								style.backgroundPosition = setItem.bg.bgImg.position
							}
							style.backgroundImage = backgroundImage
						}
						return style
					}
				} catch (e) {

				}
			},
			getStyle() {
				if (this.equipment == 'phone') {
					return {}
				}
				try {
					if (this.all_setting.length > 0) {
						let setItem = this.all_setting[0].tabList[0].config
						let style = {}
						if (setItem.bg.setWidth.type == 'px') {
							style.width = setItem.bg.setWidth.width + 'px'
						}
						return style
					}
				} catch (e) {

				}
			},
			getBoxStyle() {
				try {
					if (this.all_setting.length > 0) {
						let setItem = this.all_setting[0].tabList[0].config
						let style = {}
						if (setItem.bg.setWidth.type == 'px') {
							if (setItem.box.bgType == 'checked1') {
								style.background = setItem.box.boxSingleBgColor.bgColor
							}
							if (setItem.box.bgType == 'checked2') {
								return setItem.box.boxColor.bgColor
							}

							if (setItem.box.bgType == 'checked3') {
								let backgroundImage = `url(${setItem.box.boxBgImg.url})`
								if (setItem.box.boxBgImg.width) {
									style.backgroundSize = setItem.box.boxBgImg.width + 'px';
								} else {
									style.backgroundSize = '100%';
								}
								if (setItem.box.boxBgImg.height) {
									style.backgroundSize = style.backgroundSize + ' ' + (setItem.box.boxBgImg.height +
										'px')
								} else {
									style.backgroundSize = style.backgroundSize + ' 100%'
								}
								if (setItem.box.boxBgImg.type) {
									style.backgroundRepeat = setItem.box.boxBgImg.type
								}
								if (setItem.box.boxBgImg.position) {
									style.backgroundPosition = setItem.box.boxBgImg.position
								}
								style.backgroundImage = backgroundImage
							}
						}
						return style
					}
				} catch (e) {}
			},
			navStyle() {
				try {
					if (this.all_setting.length > 0) {
						let setItem = this.all_setting[0].tabList[0].config.nav
						let style = {}
						if (setItem.navSetHeight.toTop) {
							// position: fixed;top: 0px;z-index: 1000;
							style.position = 'fixed'
							style.top = '0px'
							style.zIndex = 1000
							console.log('navStyle', style)
						}
						if (setItem.bg.bgType == 'checked1') {
							style.background = setItem.bg.singleBgColor.bgColor
						}
						if (setItem.bg.bgType == 'checked2') {
							let str = ''
							if (setItem.navSetHeight.toTop) {
								// position: fixed;top: 0px;z-index: 1000;
								str = "position:fixed;top:0px;zIndex:1000;"
								// style.position = 'fixed'
								// style.top = '0px'
								// style.zIndex = 1000
								console.log('navStyle', style)
							}
							return str + setItem.bg.bgColor.bgColor
						}
						if (setItem.bg.bgType == 'checked3') {
							let backgroundImage = `url(${setItem.bg.bgImg.url})`
							if (setItem.bg.bgImg.width) {
								style.backgroundSize = setItem.bg.bgImg.width + 'px';
							} else {
								style.backgroundSize = '100%';
							}
							if (setItem.bg.bgImg.height) {
								style.backgroundSize = style.backgroundSize + ' ' + (setItem.bg.bgImg.height + 'px')
							} else {
								style.backgroundSize = style.backgroundSize + ' 100%'
							}
							if (setItem.bg.bgImg.type) {
								style.backgroundRepeat = setItem.bg.bgImg.type
							}
							if (setItem.bg.bgImg.position) {
								style.backgroundPosition = setItem.bg.bgImg.position
							}
							style.backgroundImage = backgroundImage
						}
						return style

					}
				} catch (e) {}
			},
			navBoxStyle() {
				if (this.equipment == 'phone') {
					return {}
				}
				try {
					if (this.all_setting.length > 0) {
						let setItem = this.all_setting[0].tabList[0].config.nav
						let style = {}
						if (setItem.bg.setWidth.type == 'px') {
							style.width = setItem.bg.setWidth.width + 'px'
						} else {
							style.width = "100%"
						}
						if (setItem.navSetHeight.height) {
							style.height = setItem.navSetHeight.height + 'px'
						} else {
							style.height = "none"
						}


						if (setItem.btoShadow.bgColor) {
							style.boxShadow =
								`0px -${setItem.btoShadow.y}px ${setItem.btoShadow.r}px ${setItem.btoShadow.bgColor} inset`
						}
						return style
					}
				} catch (e) {
					console.log('e', e)
				}
			},
			navBgBoxStyle() {
				try {
					if (this.all_setting.length > 0) {
						let setItem = this.all_setting[0].tabList[0].config.nav
						let style = {}
						if (setItem.bg.setWidth.type == 'px') {
							if (setItem.box.bgType == 'checked1') {
								style.background = setItem.box.boxSingleBgColor.bgColor
							}
							if (setItem.box.bgType == 'checked2') {
								return setItem.box.boxColor.bgColor
							}
							if (setItem.box.bgType == 'checked3') {
								let backgroundImage = `url(${setItem.box.boxBgImg.url})`
								if (setItem.box.boxBgImg.width) {
									style.backgroundSize = setItem.box.boxBgImg.width + 'px';
								} else {
									style.backgroundSize = '100%';
								}
								if (setItem.box.boxBgImg.height) {
									style.backgroundSize = style.backgroundSize + ' ' + (setItem.box.boxBgImg.height +
										'px')
								} else {
									style.backgroundSize = style.backgroundSize + ' 100%'
								}
								if (setItem.box.boxBgImg.type) {
									style.backgroundRepeat = setItem.box.boxBgImg.type
								}
								if (setItem.box.boxBgImg.position) {
									style.backgroundPosition = setItem.box.boxBgImg.position
								}
								style.backgroundImage = backgroundImage
							}
						}
						return style
					}
				} catch (e) {
					console.log('e', e)
				}
			},
			footStyle() {
				try {
					if (this.all_setting.length > 0) {
						let setItem = this.all_setting[0].tabList[0].config.foot
						let style = {}
						if (setItem.bg.bgType == 'checked1') {
							style.background = setItem.bg.singleBgColor.bgColor
						}
						if (setItem.bg.bgType == 'checked2') {
							return setItem.bg.bgColor.bgColor
						}
						if (setItem.bg.bgType == 'checked3') {
							let backgroundImage = `url(${setItem.bg.bgImg.url})`
							if (setItem.bg.bgImg.width) {
								style.backgroundSize = setItem.bg.bgImg.width + 'px';
							} else {
								style.backgroundSize = '100%';
							}
							if (setItem.bg.bgImg.height) {
								style.backgroundSize = style.backgroundSize + ' ' + (setItem.bg.bgImg.height + 'px')
							} else {
								style.backgroundSize = style.backgroundSize + ' 100%'
							}
							if (setItem.bg.bgImg.type) {
								style.backgroundRepeat = setItem.bg.bgImg.type
							}
							if (setItem.bg.bgImg.position) {
								style.backgroundPosition = setItem.bg.bgImg.position
							}
							style.backgroundImage = backgroundImage
						}
						return style

					}
				} catch (e) {
					console.log('e', e)
				}
			},
			footBoxStyle() {
				if (this.equipment == 'phone') {
					return {}
				}
				try {
					if (this.all_setting.length > 0) {
						let setItem = this.all_setting[0].tabList[0].config.foot
						let style = {}
						if (setItem.bg.setWidth.type == 'px') {
							style.width = setItem.bg.setWidth.width + 'px'
						} else {
							style.width = "100%"
						}
						if (setItem.footerSetHeight.height) {
							style.height = setItem.footerSetHeight.height + 'px'
						} else {
							style.height = "none"
						}

						if (setItem.topShadow.bgColor) {
							style.boxShadow =
								`0px ${setItem.topShadow.y}px ${setItem.topShadow.r}px ${setItem.topShadow.bgColor} inset`
						}

						return style
					}
				} catch (e) {
					console.log('e', e)
				}
			},
			footBgBoxStyle() {
				try {
					if (this.all_setting.length > 0) {
						let setItem = this.all_setting[0].tabList[0].config.foot
						let style = {}
						if (setItem.bg.setWidth.type == 'px') {
							if (setItem.box.bgType == 'checked1') {
								style.background = setItem.box.boxSingleBgColor.bgColor
							}
							if (setItem.box.bgType == 'checked2') {
								return setItem.box.boxColor.bgColor
							}
							if (setItem.box.bgType == 'checked3') {
								let backgroundImage = `url(${setItem.box.boxBgImg.url})`
								if (setItem.box.boxBgImg.width) {
									style.backgroundSize = setItem.box.boxBgImg.width + 'px';
								} else {
									style.backgroundSize = '100%';
								}
								if (setItem.box.boxBgImg.height) {
									style.backgroundSize = style.backgroundSize + ' ' + (setItem.box.boxBgImg.height +
										'px')
								} else {
									style.backgroundSize = style.backgroundSize + ' 100%'
								}
								if (setItem.box.boxBgImg.type) {
									style.backgroundRepeat = setItem.box.boxBgImg.type
								}
								if (setItem.box.boxBgImg.position) {
									style.backgroundPosition = setItem.box.boxBgImg.position
								}
								style.backgroundImage = backgroundImage
							}
						}
						return style
					}
				} catch (e) {
					console.log('e', e)
				}
			},
			getFontStyle(e) {
				let item;
				console.log('getFontStyle', this.fontList)
				this.fontList.forEach(fontItem => {
					if (fontItem.name == e) {
						item = fontItem
					}
				})
				if (item) {
					if (!document.getElementById(item.name)) {
						var style = document.createElement('style');
						style.type = 'text/css';
						style.id = item.name
						style.innerHTML = item.css;
						document.getElementsByTagName('HEAD').item(0).appendChild(style);
					}
				}
			},
			async initData(compoent) {
				console.log('compoent', compoent)
				this.loading = true
				let that = this
				try {
					let name = compoent.compoentName

					for (let i = 0; i < apiConfig.length; i++) {
						let fun = apiConfig[i]
						if (fun[name]) {
							if (compoent.requestFun) {
								console.log('name', name)
								console.log('apiConfig', apiConfig)
								for (let j = 0; j < compoent.requestFun.length; j++) {
									let funName = compoent.requestFun[j]
									let data = await fun[name]['requestData'][funName](that, 'preview', {
										// classfiy: compoent.data.classfiy
										data: compoent,
									}, that.$route)
									console.log('initData', data)
									console.log('routeinitDatainitData', this.$route)
								}
							}

						}
					}
					this.loading = false
				} catch (e) {
					console.log('e', e)
					this.loading = false
				}
			},
			async requestFun(filed) {
				console.log('requestFun')
				// let type = 'pcNav'
				// let filed = 'navList'
				// this.config.center.page.forEach(pageItem => {
				// 	if (pageItem.pageValue == this.pageValue) {
				// 		filed = pageItem.filed
				// 		type = pageItem.type
				// 	}
				// })
				// if (this.pageValue == '1') {
				// 	type = 'pcNav'
				// 	filed = 'navList'
				// }
				// if (this.pageValue == '2') {
				// 	type = 'phoneNav'
				// 	filed = 'navPhoneList'
				// }
				// if (this.pageValue == '3') {
				// 	type = 'pcFooter'
				// 	filed = 'footerList'
				// }
				// if (this.pageValue == '4') {
				// 	type = 'phoneFooter'
				// 	filed = 'footerPhoneList'
				// }
				// if (this.pageValue == '5') {
				// 	type = 'home'
				// 	filed = 'homeList'
				// }
				await this.requestInitData('navList')
				await this.requestInitData("navPhoneList")
				await this.requestInitData("footerList")
				await this.requestInitData("footerPhoneList")
				// await this.requestInitData("homeList")
				if (filed != 'navList' && filed != 'navPhoneList' && filed != 'footerList' && filed !=
					'footerPhoneList') {
					console.log('centcenterListerList', this.centerList)
					await this.requestInitData('centerList')
				}
			},
			async requestInitData(fieldList) {
				// 装配 导航
				let that = this
				for (let i = 0; i < this[fieldList].length; i++) {
					let item = this[fieldList][i]
					console.log('requestInitData item', this[fieldList])
					if (item.requestFun) {
						for (let j = 0; j < item.children.length; j++) {
							let childrenItem = item.children[j]
							for (let k = 0; k < childrenItem.children.length; k++) {
								let twoChildrenItem = childrenItem.children[k]
								for (let m = 0; m < twoChildrenItem.compontChildren.length; m++) {
									let compontChildrenItem = twoChildrenItem.compontChildren[m]
									console.log('compontChildrenItem', compontChildrenItem)
									await that.initData(compontChildrenItem)
								}
							}
						}
					}
				}
			},
		}
	}
</script>

<style lang="scss" scoped>
	.add-cart:active {
		background-color: #000;
		color: #ffffff;
	}
</style>